export enum PriceRaiseListFilterKeys {
  selectedWarehouses = 'selectedWarehouses',
  priceRaiseDateFrom = 'priceRaiseDateFrom',
  priceRaiseDateTo = 'priceRaiseDateTo',
  nextReviewDateFrom = 'nextReviewDateFrom',
  nextReviewDateTo = 'nextReviewDateTo',
  notificationSentAtFrom = 'notificationSentAtFrom',
  notificationSentAtTo = 'notificationSentAtTo',
  status = 'status',
}
